import { Dispatch, SetStateAction } from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    SelectChangeEvent,
} from "@mui/material";

type StatusFilter = {
    filterTitle: string;
    filterKey: string;
};
// filters option
const statusFiltersOptions: StatusFilter[] = [
    {
        filterTitle: "الكل",
        filterKey: "is_disabled:eq:true|false",
    },
    {
        filterTitle: "غير معطل",
        filterKey: "is_disabled:eq:false",
    },
    {
        filterTitle: "معطل",
        filterKey: "is_disabled:eq:true",
    },
];

type Props = {
    filterValues: Record<string, string>;
    setFilterValues: Dispatch<SetStateAction<Record<string, string>>>;
};

const StatusFilterBox = ({ filterValues, setFilterValues }: Props) => {
    const handleChange: any = (e: SelectChangeEvent<string>) => {
        setFilterValues({
            ...filterValues,
            status: e.target.value,
        });
    };
    return (
        <Box
            sx={{
                flex: "1",
                minWidth: "200px",
            }}
        >
            <FormControl fullWidth>
                <InputLabel>معطل / غير معطل</InputLabel>
                <Select
                    name="status_filter"
                    value={filterValues.status}
                    label="معطل / غير معطل"
                    onChange={handleChange}
                >
                    {statusFiltersOptions.map((option: StatusFilter) => {
                        return (
                            <MenuItem
                                value={option.filterKey}
                                key={option.filterKey}
                            >
                                {option.filterTitle}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
};

export default StatusFilterBox;
